<div id="content">
	<div id="main">
		<router-outlet></router-outlet>
	</div>
</div>
<bb-adservices-menu id="sidebar"></bb-adservices-menu>